import type { jiraBusinessParentFieldFragment } from '@atlassian/jira-business-fields/src/common/field-types/parent/fragment/__generated_apollo__/jiraBusinessParentFieldFragment.ts';
import type { jiraBusinessMultipleVersionFieldFragment as jiraMultipleVersionPickerField } from '@atlassian/jira-business-fields/src/common/field-types/version/fragment/__generated_apollo__/jiraBusinessMultipleVersionFieldFragment.ts';
import type { jiraBusinessSingleVersionFieldFragment as jiraSingleVersionPickerField } from '@atlassian/jira-business-fields/src/common/field-types/version/fragment/__generated_apollo__/jiraBusinessSingleVersionFieldFragment.ts';

export const isJiraBusinessFields = (_: unknown): _ is jiraBusinessFields => true;

export type jiraBusinessFields =
	| jiraBusinessParentFieldFragment
	| jiraMultipleVersionPickerField
	| jiraSingleVersionPickerField;
